import RegisterTicketListTicket from '@quickService/RegisterTicketListTicket';
import { useContext } from 'react';
import { AppContext } from '@utils/browser/app-context';
import { getCookie } from '@utils/browser/get-cookie';
import useSWR from 'swr';

export default (eventId: string, scheduleId: string) => {
  // 判断后台接口请求是否返回了数据，无论成功与否
  const { userData } = useContext(AppContext);
  const {
    data = {
      isAccept: false,
      tickets: [],
    },
  } = useSWR(
    {
      url: '/v2/activities/register/ticket/list-ticket',
      params: {
        eventId,
        scheduleId,
        userid: userData?.userid,
      },
    },
    async ({ params }) => {
      const { userid, eventId, scheduleId } = params;
      if (!getCookie('app_uid'))
        return {
          isAccept: true,
          tickets: [],
        };
      if (!userid || !eventId)
        return {
          isAccept: false,
          tickets: [],
        };
      const res = await RegisterTicketListTicket({ event_id: eventId, schedule_id: scheduleId });
      if (res.code === 0 && res.data.ticket_list) {
        return {
          isAccept: true,
          tickets: res.data.ticket_list,
        };
      }
      return {
        isAccept: true,
        tickets: [],
      };
    },
    {
      revalidateOnFocus: false,
    },
  );

  return data;
};
